var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.762 14.676A9.337 9.337 0 0 1 5.137 1.908a9.337 9.337 0 0 1 12.768 3.375 9.332 9.332 0 0 1 .032 9.338l1.411 2.426c.432.742.18 1.696-.563 2.128l1.566 2.69a1.558 1.558 0 0 1 2.129.563l1.864 3.204a4.074 4.074 0 0 1-3.263 6.116l-.96.06a4.67 4.67 0 0 1-4.332-2.312L9.866 19.318a9.333 9.333 0 0 1-8.104-4.642zm5.723-8.732a3.112 3.112 0 1 0 3.131 5.38 3.112 3.112 0 0 0-3.13-5.38z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyGray);
export default __webpack_public_path__ + "static/media/keyGray.334482292d3d0a8d75dd02e9d671b0a5.svg";
export { ForwardRef as ReactComponent };